"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonitorTypes = void 0;
var MonitorTypes;
(function (MonitorTypes) {
    MonitorTypes["Ping"] = "ping";
    MonitorTypes["LoadTime"] = "load_time";
    MonitorTypes["DNSPropagation"] = "dns_propagation";
    MonitorTypes["HTTPGet"] = "http_get";
    MonitorTypes["HTTPPost"] = "http_post";
    MonitorTypes["HTTPPut"] = "http_put";
    MonitorTypes["HTTPPatch"] = "http_patch";
    MonitorTypes["HTTPDelete"] = "http_delete";
    MonitorTypes["HTTPOptions"] = "http_options";
    MonitorTypes["HTTPHead"] = "http_head";
    MonitorTypes["HLS"] = "hls";
    MonitorTypes["Selenium"] = "selenium";
})(MonitorTypes = exports.MonitorTypes || (exports.MonitorTypes = {}));
